// src/app/interceptors/token.interceptor.ts

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = req.headers;

    if (!headers.has('Accept')) {
      headers = headers.set('Accept', 'application/json');
    }

    if (req.headers.has('X-Skip-Auth')) {
      const noAuthReq = req.clone({
        headers: headers.delete('X-Skip-Auth'),
      });
      return next.handle(noAuthReq);
    }

    const token = localStorage.getItem('auth_token');

    if (token) {
      const cloned = req.clone({
        headers: headers.set('Authorization', `Bearer ${token}`),
      });
      return next.handle(cloned);
    }

    return next.handle(req.clone({ headers }));
  }
}
